import { notCss } from './util'

export const white = 'var(--white, #FFFFFF)'
export const black = 'var(--black, #000000)'

export const focusDefault = 'var(--focus-default, #F3F7FB)'
export const focusHigh = 'var(--focus-default, #E1EDFA)'
export const importantDimmed = 'var(--important-dimmed #F7B2C7)'

export const anthracite050 = 'var(--anthracite-050, #EAEDF3)'
export const anthracite100 = 'var(--anthracite-100, #CBD3DC)'
export const anthracite200 = 'var(--anthracite-200, #ABB6C3)'
export const anthracite300 = 'var(--anthracite-300, #8B99AA)'
export const anthracite400 = 'var(--anthracite-400, #738497)'
export const anthracite500 = 'var(--anthracite-500, #5B6F85)'
export const anthracite600 = 'var(--anthracite-600, #4E6174)'
export const anthracite700 = 'var(--anthracite-700, #3F4E5E)'
export const anthracite800 = 'var(--anthracite-800, #303C49)'
export const anthracite900 = 'var(--anthracite-900, #1E2832)'
export const anthracitePrimary = 'var(--anthracite-primary)'
export const anthracite = notCss({
  50: anthracite050,
  100: anthracite100,
  200: anthracite200,
  300: anthracite300,
  400: anthracite400,
  500: anthracite500,
  600: anthracite600,
  700: anthracite700,
  800: anthracite800,
  900: anthracite900,
  primary: anthracitePrimary,
} as const)

export const red050 = 'var(--red-050, #FDE2E8)'
export const red100 = 'var(--red-100, #FAB7C6)'
export const red200 = 'var(--red-200, #F6889E)'
export const red300 = 'var(--red-300, #F05C7C)'
export const red400 = 'var(--red-400, #EA345E)'
export const red500 = 'var(--red-500, #E40045)'
export const red600 = 'var(--red-600, #D60044)'
export const red700 = 'var(--red-700, #C20041)'
export const red800 = 'var(--red-800, #AD0040)'
export const red900 = 'var(--red-900, #8A003B)'
export const redPrimary = 'var(--red-primary)'
export const red = notCss({
  50: red050,
  100: red100,
  200: red200,
  300: red300,
  400: red400,
  500: red500,
  600: red600,
  700: red700,
  800: red800,
  900: red900,
  primary: redPrimary,
} as const)

export const silver050 = 'var(--silver-050, #F8F8F8)'
export const silver100 = 'var(--silver-100, #F0F0F0)'
export const silver200 = 'var(--silver-200, #E5E5E5)'
export const silver300 = 'var(--silver-300, #D3D3D3)'
export const silver400 = 'var(--silver-400, #AFAFAF)'
export const silver500 = 'var(--silver-500, #8F8F8F)'
export const silver600 = 'var(--silver-600, #676767)'
export const silver700 = 'var(--silver-700, #545454)'
export const silver750 = 'var(--silver-750, #454545)'
export const silver800 = 'var(--silver-800, #353535)'
export const silver825 = 'var(--silver-825, #303030)'
export const silver850 = 'var(--silver-850, #252525)'
export const silver855 = 'var(--silver-855, #202020)'
export const silver900 = 'var(--silver-900, #161616)'
export const silverPrimary = 'var(--silver-primary)'
export const silver = notCss({
  50: silver050,
  100: silver100,
  200: silver200,
  300: silver300,
  400: silver400,
  500: silver500,
  600: silver600,
  700: silver700,
  800: silver800,
  850: silver850,
  900: silver900,
  primary: silverPrimary,
} as const)

export const blue050 = 'var(--blue-050, #E5F2F9)'
export const blue100 = 'var(--blue-100, #BFDDF1)'
export const blue200 = 'var(--blue-200, #99C9E8)'
export const blue300 = 'var(--blue-300, #76B3DE)'
export const blue400 = 'var(--blue-400, #5EA4D8)'
export const blue500 = 'var(--blue-500, #4B96D2)'
export const blue600 = 'var(--blue-600, #4489C5)'
export const blue700 = 'var(--blue-700, #3875B2)'
export const blue800 = 'var(--blue-800, #3165A0)'
export const blue900 = 'var(--blue-900, #244B84)'
export const bluePrimary = 'var(--blue-primary)'
export const blue = notCss({
  50: blue050,
  100: blue100,
  200: blue200,
  300: blue300,
  400: blue400,
  500: blue500,
  600: blue600,
  700: blue700,
  800: blue800,
  900: blue900,
  primary: bluePrimary,
} as const)

export const green050 = 'var(--green-050, #F3F7E4)'
export const green100 = 'var(--green-100, #DFE9BC)'
export const green200 = 'var(--green-200, #CADB91)'
export const green300 = 'var(--green-300, #B3CD63)'
export const green400 = 'var(--green-400, #A2C33D)'
export const green500 = 'var(--green-500, #91B900)'
export const green600 = 'var(--green-600, #81AA00)'
export const green700 = 'var(--green-700, #6B9700)'
export const green800 = 'var(--green-800, #558300)'
export const green900 = 'var(--green-900, #2D6300)'
export const greenPrimary = 'var(--green-primary)'
export const green = notCss({
  50: green050,
  100: green100,
  200: green200,
  300: green300,
  400: green400,
  500: green500,
  600: green600,
  700: green700,
  800: green800,
  900: green900,
  primary: greenPrimary,
} as const)

export const yellow050 = 'var(--yellow-050, #FFF8E0)'
export const yellow100 = 'var(--yellow-100, #FFEDB0)'
export const yellow200 = 'var(--yellow-200, #FFE17C)'
export const yellow300 = 'var(--yellow-300, #FFD743)'
export const yellow400 = 'var(--yellow-400, #FFCD00)'
export const yellow500 = 'var(--yellow-500, #FFC300)'
export const yellow600 = 'var(--yellow-600, #FFB500)'
export const yellow700 = 'var(--yellow-700, #FFA100)'
export const yellow800 = 'var(--yellow-800, #FF8F00)'
export const yellow900 = 'var(--yellow-900, #FF6D00)'
export const yellowPrimary = 'var(--yellow-primary)'
export const yellow = notCss({
  50: yellow050,
  100: yellow100,
  200: yellow200,
  300: yellow300,
  400: yellow400,
  500: yellow500,
  600: yellow600,
  700: yellow700,
  800: yellow800,
  900: yellow900,
  primary: yellowPrimary,
} as const)
